// eslint-disable-next-line no-unused-vars
import React from 'react';

import ProductGridSliderContainer from 'Containers/Templates/ProductGridSlider';

const ProductGridSlider = {
  label: 'Product Grid Slider',
  fields: {
    products: {
      type: 'array',
      label: 'Products',
      arrayFields: {
        id: { type: 'text', visible: false },
        productId: { type: 'text', label: 'Product ID' },
      },
      defaultItemProps: index => ({
        id: `product-${Date.now()}-${index}`,
        productId: '',
      }),
      getItemSummary: (item, index) => item.productId || `Product ${(index || 0) + 1}`,
      min: 1,
      max: 100,
    },
    desktopItems: { type: 'number', label: 'Items on desktop', min: 1, max: 6 },
    tabletItems: { type: 'number', label: 'Items on tablet', min: 1, max: 4 },
    mobileItems: { type: 'number', label: 'Items on mobile', min: 1, max: 2 },
    gap: { type: 'number', label: 'Gap (px)', min: 0, max: 64 },
    showArrows: {
      type: 'radio',
      label: 'Show arrows',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    showDots: {
      type: 'radio',
      label: 'Show dots',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    autoPlay: {
      type: 'radio',
      label: 'Auto play',
      options: [
        { label: 'Yes', value: true },
        { label: 'No', value: false },
      ],
    },
    autoPlaySpeed: {
      type: 'number',
      label: 'Auto play interval (ms)',
      min: 1000,
      max: 20000,
      step: 500,
    },
  },
  defaultProps: {
    products: [
      { id: 'product-1', productId: '' },
      { id: 'product-2', productId: '' },
    ],
    desktopItems: 4,
    tabletItems: 2,
    mobileItems: 1,
    gap: 20,
    showArrows: true,
    showDots: false,
    autoPlay: false,
    autoPlaySpeed: 3000,
  },
  render: ({
    products,
    desktopItems,
    tabletItems,
    mobileItems,
    gap,
    showArrows,
    showDots,
    autoPlay,
    autoPlaySpeed,
  }) => (
    <ProductGridSliderContainer
      selections={ products }
      desktopItems={ desktopItems }
      tabletItems={ tabletItems }
      mobileItems={ mobileItems }
      gap={ gap }
      showArrows={ showArrows }
      showDots={ showDots }
      autoPlay={ autoPlay }
      autoPlaySpeed={ autoPlaySpeed }
    />
  ),
};

// eslint-disable-next-line import/prefer-default-export
export { ProductGridSlider };
